import { render, staticRenderFns } from "./PublicForm.vue?vue&type=template&id=052fb132&scoped=true"
import script from "./PublicForm.vue?vue&type=script&lang=js"
export * from "./PublicForm.vue?vue&type=script&lang=js"
import style0 from "./PublicForm.vue?vue&type=style&index=0&id=052fb132&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052fb132",
  null
  
)

export default component.exports